var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCourrier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.272 13.3921H11.7504C10.3542 13.3921 9.22241 14.5239 9.22241 15.9201V36.3393C9.22241 37.7355 10.3542 38.8673 11.7504 38.8673H42.272C43.6682 38.8673 44.8 37.7355 44.8 36.3393V15.9201C44.8 14.5239 43.6682 13.3921 42.272 13.3921Z",
    fill: "#80D4DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3696 35.0145H5.72319C3.80319 35.0145 2.23999 33.4529 2.23999 31.5313V11.9761C2.23999 10.0561 3.80159 8.49292 5.72319 8.49292H37.3696C39.2896 8.49292 40.8528 10.0561 40.8528 11.9761V31.5313C40.8528 33.4513 39.2896 35.0145 37.3696 35.0145ZM5.72319 10.4145C4.86079 10.4145 4.15999 11.1153 4.15999 11.9777V31.5329C4.15999 32.3953 4.86079 33.0961 5.72319 33.0961H37.3696C38.232 33.0961 38.9328 32.3953 38.9328 31.5329V11.9777C38.9328 11.1153 38.232 10.4145 37.3696 10.4145H5.72319Z",
    fill: "#5A348C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5472 26.7408C19.9648 26.7408 18.4416 26.0736 17.368 24.912L4.13119 10.5744C3.77119 10.1856 3.79519 9.57761 4.18559 9.21761C4.57599 8.85761 5.18239 8.88161 5.54239 9.27201L18.7792 23.608C19.5008 24.3888 20.4832 24.8208 21.5472 24.8208C22.6112 24.8208 23.5936 24.3904 24.3152 23.608L37.552 9.27201C37.912 8.88161 38.5184 8.85761 38.9088 9.21761C39.2976 9.57761 39.3232 10.184 38.9632 10.5744L25.7264 24.9104C24.6528 26.0736 23.1296 26.7392 21.5472 26.7392V26.7408Z",
    fill: "#5A348C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourrier);
export default __webpack_public_path__ + "static/media/courrier.6c1fa70a690d30547d1fa73c45d7c5e2.svg";
export { ForwardRef as ReactComponent };